import React, { useState } from "react";
import UserContext from '../dataContext'
import GestionFichesHome from "../Components/Gestion/Fiches Home/GestionFichesHome";
import SeasonalDatesManager from "../Components/Gestion/SeasonalDatesManager";
import SeasonalCalendarView from "../Components/Gestion/SeasonalCalendarView";
import '../assets/scss/gestion.scss'
import Spinner from '../Components/Spinner';
import * as XLSX from 'xlsx';
import AirbnbScraper from '../Components/Gestion/AirbnbScraper';

export default function Gestion() {
    const userContext = React.useContext(UserContext)
    const [, setFile] = useState(null);
    const [isLoading, setIsLoading] = useState(false)
    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
    const [seasonalDates, setSeasonalDates] = useState({
        lowSeason: [{ startMonth: '', startDay: '', endMonth: '', endDay: '' }],
        midSeason: [{ startMonth: '', startDay: '', endMonth: '', endDay: '' }],
        highSeason: [{ startMonth: '', startDay: '', endMonth: '', endDay: '' }]
    });

    if (userContext.loading) {
        return (
            <div className={"col cardsContainer mx-1 p-2 mt-3 mt-md-0"}>
                <div className={"row justify-content-between"}>
                    <div>
                        <h1 className="blue fw-bold text-center">Gestion</h1>
                    </div>
                </div>
                <Spinner strokeWidth={9} width={40} color={"#003952"} />
                <h2 className="text-center">Chargement...</h2>
            </div>
        )
    } else if (!userContext.loading) {
        return (
            <>
                <div>
                    <div className={"row justify-content-center"}>
                        <div className="">
                            <h1 className="blue fw-bold text-center">Gestion</h1>

                            {/* Year Filter */}
                            <div className="row justify-content-center mt-3">
                                <div className="col-md-4">
                                    <div className="card cardShadow year-filter-container">
                                        <div className="card-body text-center">
                                            <label htmlFor="yearFilter" className="form-label fw-bold">Filtrer par année:</label>
                                            <select
                                                id="yearFilter"
                                                value={selectedYear}
                                                onChange={(e) => setSelectedYear(parseInt(e.target.value))}
                                                className="form-select"
                                            >
                                                <option value={2024}>2024</option>
                                                <option value={2025}>2025</option>
                                                <option value={2026}>2026</option>
                                                <option value={2027}>2027</option>
                                                <option value={2028}>2028</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Two column layout */}
                            <div className={"row mt-5 gap-3"}>
                                {/* Left column - Seasonal Dates */}
                                <div className={"col-md-5 cardsContainer cardShadow p-3"}>
                                    <SeasonalDatesManager
                                        userContext={userContext}
                                        onSeasonalDatesChange={setSeasonalDates}
                                        selectedYear={selectedYear}
                                        onYearChange={setSelectedYear}
                                    />
                                </div>

                                {/* Right column - Calendar View */}
                                <div className={"col-md-6 cardsContainer cardShadow p-3"}>
                                    <SeasonalCalendarView
                                        seasonalDates={seasonalDates}
                                        selectedYear={selectedYear}
                                        onYearChange={setSelectedYear}
                                    />
                                </div>
                            </div>

                            {/* Airbnb Scraper moved below */}
                            <div className={"w-48 cardsContainer cardShadow mx-auto p-2 mt-5"}>
                                <div className={"row justify-content-between gap-2"}>
                                    <div className="row flex-column align-items-center text-center">
                                        <h2 className="blue fw-bold">Scraping Airbnb</h2>
                                        <p className="black"><strong>Entrez une URL Airbnb pour télécharger ses images</strong></p>
                                        <AirbnbScraper />
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    {userContext?.data?.people?.Client?.find(({ lastName }) => lastName === "Test") && (<div className={"w-full cardsContainer cardShadow mx-1 p-2 mt-5"}>
                        <div className={"row justify-content-between gap-2"}>
                            <div className="row flex-column align-items-center text-center">
                                <h2 className="blue fw-bold">Modification de la stucture des fiches Home</h2>
                                <GestionFichesHome context={userContext} />
                            </div>
                        </div>
                    </div>)}

                </div>
            </>
        )
    }

    else { console.log("exeption") }
}


// Hi someone from the future where this breaks because the person uploading doesnt have commas as separators!
// You could add a dropdown where the person select their separator!
// Seems easy enough from here.... though i won't do it myself i have more stuff to do lol

// function csvJSONString(csv) {

//     let lines = csv.split("\n");

//     let result = [];

//     // NOTE: If your columns contain commas in their values, you'll need
//     // to deal with those before doing the next step
//     // (you might convert them to &&& or something, then covert them back later)
//     let headers = lines[0].split(",");

//     for (let i = 1; i < lines.length; i++) {

//         let obj = {};
//         let currentline = lines[i].split(",");

//         for (let j = 0; j < headers.length; j++) {
//             obj[headers[j]] = currentline[j];
//         }

//         result.push(obj);

//     }

//     return JSON.stringify(result); //JSON
// }